<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-button
      slot="start"
      (click)="close()"
      fill="clear"
      [attr.aria-label]="'COMMON.LABELS.CLOSE' | translate"
      [title]="'COMMON.LABELS.CLOSE' | translate"
    >
      <svg-icon
        slot="icon-only"
        key="close"
        aria-hidden="true"
      ></svg-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content
  fullscreen="true"
  scroll-y="false"
  color="dark"
>
  <ng-container *ngIf="renderSlideshow; else singleImageTemp">
    <swiper-container
      #swiperRef
      zoom="true"
      [modules]="swiperModules"
      (swiperslideprevtransitionend)="handleSlidePrevEnd($event)"
      (swiperslidenexttransitionend)="handleSlideNextEnd($event)"
      [loop]="swiperConfig['loop']"
      [simulateTouch]="swiperConfig['simulateTouch']"
      [initialSlide]="swiperConfig['initialSlide']"
    >
      <swiper-slide *ngFor="let image of props.images">
        <div class="swiper-zoom-container">
          <img [src]="image?.url" />
        </div>
      </swiper-slide>
    </swiper-container>
  </ng-container>
  <ng-template #singleImageTemp>
    <div class="flex--center h-100">
      <pinch-zoom [properties]="pinchZoomConfig">
        <img [src]="props.images[0]?.url" />
      </pinch-zoom>
    </div>
  </ng-template>
</ion-content>

<ion-footer
  *ngIf="renderSlideshow"
  mode="md"
>
  <ion-toolbar>
    <ion-buttons class="flex--center">
      <ion-button
        class="prev-btn"
        (click)="previous()"
        fill="clear"
        [attr.aria-label]="'COMMON.LABELS.PREV' | translate"
        [title]="'COMMON.LABELS.PREV' | translate"
      >
        <svg-icon
          class="font--xl"
          slot="icon-only"
          key="chevron-back"
          aria-hidden="true"
        ></svg-icon>
      </ion-button>
      <ion-label class="text--md counter">
        {{ activeSlide }}/{{ props.images?.length }}
      </ion-label>
      <ion-button
        class="next-btn"
        (click)="next()"
        fill="clear"
        [attr.aria-label]="'COMMON.LABELS.NEXT' | translate"
        [title]="'COMMON.LABELS.NEXT' | translate"
      >
        <svg-icon
          class="font--xl"
          slot="icon-only"
          key="chevron-forward"
          aria-hidden="true"
        ></svg-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
